<template>
  <div class="TreeLibraryComponent">

    <p>{{lang.infotext_1}}</p>
    <b-form-input id="input-search" v-model="searchString" :placeholder="lang.placeholder_Search"></b-form-input>
    <br>
    <ul v-if="isData"  :id="id" class="library_ul">
      <ItemTreeLibrary :action="action" :lang="lang.TreeItem" :searchString="searchString"  class="item"   :model="dataTree"  :edit="iscategory" ></ItemTreeLibrary>
    </ul>
    <LoaderComponent  v-if="!isData"></LoaderComponent>

 </div>
</template>

<script>
import ItemTreeLibrary from "@/components/shared/ItemTreeLibrary"
import LoaderComponent from "@/components/shared/LoaderComponent"
import { mapGetters } from 'vuex'


export default {
  name: 'TreeLibraryComponent',
  components: {
    ItemTreeLibrary,
    LoaderComponent
  },
  props:{
      iscategory: Boolean,
      reloadTree: Boolean,
      lang: Object,
      action: Boolean
  },
  data: function () {
      return {
          open: true,
          dataItem:{},

          id: "tree_"+this._uid,
          name:'',
          searchString: ""

      };
  },
  computed: {

    ...mapGetters({
      dataTree: 'dataLibraryTree',
      reloadAfterDeleteTreeLibraryItem: 'reloadAfterDeleteTreeLibraryItem',
      
    }),
    isData(){


      return this.$store.getters.dataLibraryTree.name != ""
    }
  },
  watch: {
         
    reloadAfterDeleteTreeLibraryItem: function(new_isData, old_isData)
    {
      if (new_isData)
      {
        this.loadData();
        this.$store.dispatch("reloadAfterDeleteTreeLibraryItem",false )
      }
    },

    reloadTree: function(new_isData, old_isData)
    {
      this.loadData();
    }
  },
  mounted () {
    
    
  },
  created () {
    

    this.$store.dispatch("deleteLibraryCategoryMapping");

    this.loadData();

    //this.setCategory();
  },
  updated() {
    
  },
  methods: {
    loadData(){
      
       this.$store.dispatch(this.$store.getters.sectionPrefix + "_getCategories", this.id);
    }

  }
}
</script>


<style lang="scss">

  .library_bold {
    font-weight: bold;
  }

  .library_ul label{
    margin-right: 0px;
  }
  .library_li{
    margin-top: 5px;
    margin-left: 0px;
    width: 100%;

  }
  .library_img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
    margin-left: 5px;
  }
  .library_ul {
    padding-left: 18px;
    line-height: 1.5em;
    list-style-type: none;

  }


</style>



// WEBPACK FOOTER //
// src/components/shared/TreeLibraryComponent.vue